// extracted by mini-css-extract-plugin
module.exports = {"cardItem":"CardItem_cardItem__1-NJN","photoPlaceholder":"CardItem_photoPlaceholder__2RYz3","loadingColorWave":"CardItem_loadingColorWave__vnaSj"};